import * as React from 'react';
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { ContactButton, Container, Title, Message } from './ErrorScreen.styles.js';
import { useOverrides } from '../../hooks/useOverrides/useOverrides.js';
import { StraightFace } from '../../Icons/components/StraightFace.js';

const defaultComponents = {
    ContactButton: ContactButton,
    Container: Container,
    Title: Title,
    Message: Message
};
const ErrorScreen = ({ className ="" , title , message , contactButtonText , onContactButtonClick =()=>void 0 , overrides ={}  })=>{
    const theme = useContext(ThemeContext);
    const { Container: { component: Container , props: containerProps  } , Title: { component: Title , props: titleProps  } , Message: { component: Message , props: messageProps  } , ContactButton: { component: ContactButton , props: contactButtonProps  }  } = useOverrides(defaultComponents, overrides);
    return /*#__PURE__*/ React.createElement(Container, {
        className: className,
        ...containerProps
    }, /*#__PURE__*/ React.createElement(StraightFace, {
        color: theme.colors["Level 4"]
    }), /*#__PURE__*/ React.createElement(Title, titleProps, title), /*#__PURE__*/ React.createElement(Message, messageProps, message), /*#__PURE__*/ React.createElement(ContactButton, {
        onClick: onContactButtonClick,
        ...contactButtonProps
    }, contactButtonText));
};

export { ErrorScreen };
